import React from 'react';
import { useDispatch } from 'react-redux';

import labster from 'app/shared/utils/labster';
import { LabsterDashboard } from '@zg-rentals/particles-js-labster-ui';

import { EXPERIMENTS_PATH } from 'app/shared/constants/RouteConstants';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import PermissionCheck from 'app/shared/components/PermissionCheck';

const ExperimentsPage = () => {
    const dispatch = useDispatch();

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={EXPERIMENTS_PATH}>
                <LabsterDashboard
                    dispatch={dispatch}
                    labster={labster}
                />
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

export default ExperimentsPage;
